import { useState } from 'react';
import SortAscIcon from '../../../../../assets/sort-asc.svg';
import SortDescIcon from '../../../../../assets/sort-desc.svg';
import {
  auditLogsTableColumns,
  auditLogsTableColumnsWithSeverity,
} from './AuditLogsTableHeader.consts';
import { AuditLogsTableHeaderProps } from './AuditLogsTableHeader.types';

export function AuditLogsTableHeader({
  showSeverity = false,
  sortBy,
  sortOrder,
  onSort,
}: AuditLogsTableHeaderProps) {
  const [hoveredColumn, setHoveredColumn] = useState<string | null>(null);
  const columns = showSeverity
    ? auditLogsTableColumnsWithSeverity
    : auditLogsTableColumns;

  return (
    <thead>
      <tr className="w-full flex flex-row">
        {columns.map((column) => {
          const isSortable = Boolean(column.sortable && onSort);
          const isActive = isSortable && sortBy === column.sortKey;
          const isHovered = isSortable && hoveredColumn === column.sortKey;
          const showIcon = isSortable && (isActive || isHovered);

          return (
            <th
              key={column.label}
              className={`${
                column.width
              } flex items-center py-3 px-6 gap-2 bg-gray-40 text-xs font-medium tracking-wider text-gray-550 uppercase ${
                isSortable ? 'cursor-pointer' : ''
              }`}
              onClick={() => isSortable && onSort?.(column.sortKey!)}
              onMouseEnter={() => isSortable && setHoveredColumn(column.sortKey!)}
              onMouseLeave={() => setHoveredColumn(null)}
            >
              <span>{column.label}</span>
              {showIcon && (
                <img
                  src={
                    isActive && sortOrder === 'desc'
                      ? SortDescIcon
                      : SortAscIcon
                  }
                  alt="Sort"
                  className="w-4 h-4"
                />
              )}
            </th>
          );
        })}
      </tr>
    </thead>
  );
}
